import MainPreviewI from '../types.ts';

const prevInit: MainPreviewI['prevInit'] = function () {
    this.setState({ isPreviewImageReady: true }, this.init.bind(this));
};

export default prevInit;
